if (!customElements.get('lc22-bogo-offer')) {
  customElements.define('lc22-bogo-offer', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.addEventListener('change', () => this.update());
      customElements.whenDefined('product-form').then(() => this.update());
    }
    update() {
      const form = this.closest('product-form');
      if (!form) return;
      const selects = [...this.querySelectorAll('select')];
      const chosen = selects.map(select => this.variants.find(v => String(v.id) === select.value));
      const paid = chosen[0];
      if (!paid) return;
      form.querySelectorAll('input[name="id"]').forEach(input => { input.value = paid.id; });
      const container = form.querySelector('[data-ref="add-to-cart-button-container"]');
      if (container) { container.dataset.price = paid.price; container.dataset.compareAtPrice = paid.compare_at_price || paid.price; }
      const button = form.querySelector('[data-ref="add-to-cart-button"]');
      if (button) button.disabled = chosen.some(v => !v?.available);
      chosen.forEach((v, i) => {
        const image = selects[i].closest('.lc22-bogo__choice').querySelector('img');
        if (image && v?.featured_image?.src) { image.srcset = ''; image.src = v.featured_image.src + '&width=160'; image.alt = v.title; }
      });
      if (typeof form.onFormUpdated === 'function') form.onFormUpdated();
    }
  });
}
